export default class Config {
    static app_token = "600f40e0c93c93dc3dd49c3e9ab09087acfb5f47";
    static app_name = "PROFESSIONAL";
    static base_url = process.env.VUE_APP_BASE_URL_API ?? "https://api.ubbimed.com.br";
    static site_url = process.env.VUE_APP_SITE_URL ?? "https://ubbimed.com.br";
    static site_url_prof = process.env.VUE_APP_SITE_URL_PROF ?? "https://profissional.ubbimed.com.br";
    static marketplace_url = process.env.VUE_APP_MARKETPLACE_URL ?? "https://marketplace.ubbimed.com.br/";
    static timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
}